module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"unlock":"Выберите тарифный план без ограничений, чтобы смотреть прогнозы на весь месяц и учитывать личную благоприятность.","tariffs":"Тарифные планы"}}')
  delete Component.options._Ctor
}
